import { IActionFn } from '@/store/types';
import * as Types from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询官网首页配置
export const queryWebsiteHomeConfigs: IActionFn<Types.IModuleState> = async ({ commit }) => {
  try {
    commit('setWebsiteHomeConfigs', { data: null, loading: true });
    const res: any = await $http.get('/v1/website/page/home/config', { ignoreCode: [21002] });

    // 解析各个模块的配置
    const { contents = [], ...pageRest } = (res || {}) as any;
    const contentList = contents.map((item: any) => {
      const { details = [], ...contentRest } = item;
      const config = JSON.parse(details[0]?.config || 'null');
      return {  ...contentRest, details:  config ? [{ config }] : [] };
    });
    const data = { ...pageRest, contents: contentList };
    commit('setWebsiteHomeConfigs', { data, loading: false });
  } catch (e) {
    commit('setWebsiteHomeConfigs', { data: null, loading: false });
  }
};

// 查询官网首页已发布的配置
export const queryWebsiteHomePublishConfigs: IActionFn<Types.IModuleState> = async ({ commit }) => {
  try {
    commit('setWebsiteHomePublishConfigs', { data: null, loading: true });
    const res: any = await $http.get('/v1/website/page/home/publishconfigbytype');

    // 解析各个模块的配置
    const { contents = [], ...pageRest } = (res || {}) as any;
    const contentList = contents.map((item: any) => {
      const { details = [], ...contentRest } = item;
      const config = JSON.parse(details[0]?.config || 'null');
      return {  ...contentRest, details:  config ? [{ config }] : [] };
    });
    const data = { ...pageRest, contents: contentList };
    commit('setWebsiteHomePublishConfigs', { data, loading: false });
  } catch (e) {
    commit('setWebsiteHomePublishConfigs', { data: null, loading: false });
  }
};

// 保存配置
export const saveWebsiteHomeConfigs: IActionFn<Types.IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/website/page/saveorupdateconfig', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 发布配置
export const publishWebsiteHomeConfigs: IActionFn<Types.IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/website/page/publish', payload);
    store.commit('common/setToast', { visible: true, text: '发布成功' });
  } finally {
    commit('setLoading', false);
  }
};
